module.exports = __webpack_public_path__ + "static/media/icon-css3.0c2aca13.svg";